export { CampaignBannerSm as default } from './CampaignBannerSm';
